import { LoanAccountDetail } from '@treasury/domain/accounts/types/loan-account-details.entity';
import { LabeledList, TmBaseComponent } from '@treasury/presentation';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'loan-details';

@customElement(tagName)
export class LoanDetails extends TmBaseComponent {
    @property({ attribute: false })
    public loan?: LoanAccountDetail;

    protected render() {
        if (!this.loan) {
            return nothing;
        }

        const loanInfoList = new LabeledList(
            {
                originalLoanDate: this.loan.originalLoanDate,
                originalBalance: this.loan.originalBalance,
                maturityDate: this.loan.maturityDate,
                interestRate: this.loan.interestRate,
                currentPayoff: this.loan.currentPayoff,
                payoffGoodThru: this.loan.payoffGoodThru,
                interestPaidYtd: this.loan.interestPaidYtd,
            },
            undefined,
            { interestPaidYtd: 'Interest Paid YTD' }
        );

        const paymentInfoList = new LabeledList({
            paymentDueDate: this.loan.paymentDueDate,
            paymentAmountDue: this.loan.paymentAmountDue,
            pastAmountDue: this.loan.pastAmountDue,
            totalAmountDue: this.loan.paymentTotalAmount,
        });

        const billingDetailsList = new LabeledList({
            principal: this.loan.billedPrincipal,
            interest: this.loan.billedInterest,
            escrow: this.loan.billedEscrow,
            lateCharge: this.loan.billedLateCharge,
            otherCharge: this.loan.billedOtherCharge,
        });

        return html`<div
            class="flex flex-wrap flex-col md:flex-row gap-3 md:gap-14 justify-start md:justify-center"
        >
            <div>
                <h3>Loan Information</h3>
                <tm-labeled-list .list=${loanInfoList}></tm-labeled-list>
            </div>
            <div>
                <h3>Payment Information</h3>
                <tm-labeled-list .list=${paymentInfoList}></tm-labeled-list>
            </div>
            <div>
                <h3>Billing Details</h3>
                <tm-labeled-list .list=${billingDetailsList}></tm-labeled-list>
            </div>
        </div>`;
    }
}
